import {combineReducers} from 'redux';
import debtCalculator from './debtCalculator';
import scrolling from './scrolling';

export const debtRepaymentCalculator = combineReducers({
    debtCalculator,
    scrolling
});